import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core';
const _ = require('lodash');
@Injectable()

export class SharedService {
  @Output() fire: EventEmitter<any> = new EventEmitter();
  @Output() dataChangeObserver: EventEmitter<any> = new EventEmitter();

  private arrData: Array<any> = [];
  private value: any;

   constructor() {
     console.log('shared service started');
   }

   resetData() {
       this.arrData = [];
   }

   shareDataUpdate() {
       this.fire.emit({type: 'update', data: this.arrData});
   }

   shareComponentDelete(value: any, templateID: number) {
       this.arrData[value.templateID] = _.cloneDeep(value);
       let showErrorMsg = (value.default && value.isDeleted) ? true : false;
       this.fire.emit({type: 'delete', data: templateID, showErrorMsg});
   }

   change() {
        this.fire.emit({type: 'dataChange1', data: this.arrData});
   }

   getValue() {
        return this.arrData;
   }

   setValue(templateID: number, value: any, resetChecked: Boolean) {
       this.arrData[value.templateID] = _.cloneDeep(value);
       if (!resetChecked) {
           return;
       }
       for (let i = 0; i < this.arrData.length; i++) {
            this.arrData[i].default = (this.arrData[i].templateID === templateID) ? true : false;
       }
   }

   getEmittedValue() {
       return this.fire;
   }

   emitEvent() {
       this.dataChangeObserver.emit({type: 'dataChange2', data: this.arrData});
       return this.dataChangeObserver;
   }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/shared-service.ts